// @ts-nocheck
import React from "react";
import { useState } from "react";
import { FaUserAlt } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import useFetch from "../../../ApiClient/GetApi";
import { PostApi } from "../../../ApiClient/PostApi";
import { error_toaster, success_toaster } from "../../toaster/Toaster";
import Header from "../layout/Header";
import { useDisclosure } from "@chakra-ui/react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
} from "@chakra-ui/react";
import { Loader2 } from "../../loader/Loader";
import Moment from "react-moment";
export default function Reviews() {
  const location = useLocation();

  const { data, reFetch } = useFetch(
    `booking/booking_reviews/${location.state.bookingId}`
  );

  const [reply, setReply] = useState("");
  const [newcomment, setNewComment] = useState("");
  const [loading, SetLoading] = useState(false);

  const {
    isOpen: CommentOpen,
    onOpen: CommentOnOpen,
    onClose: CommentOnClose,
  } = useDisclosure();

  const add_reply = async (id) => {
    if (reply === "") {
      error_toaster("Please enter your comment!");
      return false;
    }
    SetLoading(true);
    const res = await PostApi("users/home/add_comment", {
      BookingId: location.state.bookingId,
      CommentId: id,
      comment: reply,
    });
    if (res.data.status === "1") {
      SetLoading(false);
      setReply("");
      success_toaster(res.data.message);
      reFetch();
      window.location.reload(false);
    } else {
      SetLoading(false);
      error_toaster(res.data.message);
    }
  };

  const modal_open = () => {
    CommentOnOpen();
  };

  const add_comment = async () => {
    if (newcomment === "") {
      error_toaster("Please enter your comment!");
      return false;
    }
    SetLoading(true);
    const res = await PostApi("users/home/add_comment", {
      BookingId: location.state.bookingId,

      comment: newcomment,
    });
    if (res.data.status === "1") {
      reFetch();
      SetLoading(false);
      setNewComment("");
      setReply("");
      CommentOnClose();
      success_toaster(res.data.message);
    } else {
      SetLoading(false);
      error_toaster(res.data.message);
    }
  };

  // const remove_comment = async (id) => {
  //   SetLoading(true);
  //   const res = await PostApi("users/home/delete_comment", {
  //     CommentId: id
  //   });
  //   if (res.data.status === "1") {
  //     reFetch();
  //     SetLoading(false);
  //     success_toaster(res.data.message);
  //   }
  //   else {
  //     SetLoading(false);
  //     error_toaster(res.data.message);
  //   }
  // }
  const textareaStyle =
    "block border border-black border-opacity-20 rounded-xl px-4 py-3 font-normal text-base bg-[#f4f5fa] w-full placeholder:text-black placeholder:text-opacity-40 focus:ring-0  resize-none";
  return (
    <section className="font-soehne">
      <Header />
      <section
        className="xl:w-4/5 w-11/12 bg-themeGray2 mx-auto lg:my-20 my-12 sm:py-10 py-6 sm:px-8 px-4 
            rounded-lg space-y-8"
      >
        {data.length === 0 ? (
          <Loader2 />
        ) : (
          <div className="grid lg:grid-cols-12 gap-x-10 gap-y-12">
            <div className="lg:col-span-8 space-y-12">
              <div className="flex items-center gap-x-5">
                <div className="bg-white p-3 w-fit rounded-fullest">
                  <img
                    src="images/sendParcel/box.webp"
                    alt="box"
                    className="max-w-[28px]"
                  />
                </div>
                <div>
                  <h1 className="font-medium text-2xl text-themeBlue">
                    Order#{data?.data?.booking.id ?? ""}
                  </h1>
                  <h6 className="font-medium text-base text-black text-opacity-40">
                    Service : {data?.data?.booking.serviceType ?? ""}
                  </h6>
                </div>
              </div>
              <div>
                {data?.data?.comments?.map((comment) => (
                  <div>
                    <div className="flex sm:flex-row flex-col items-start gap-x-5 gap-y-4">
                      <div className="space-y-8">
                        <div className="space-y-1">
                          <div className="flex items-center gap-x-4">
                            <div className="bg-white p-3 w-fit rounded-fullest">
                              <FaUserAlt size={32} />
                            </div>
                            <h3 className="font-medium text-base">
                              {comment.User.firstName +
                                " " +
                                comment.User.lastName}
                            </h3>
                            {/* <div><button onClick={() => remove_comment(comment.id)} className="py-1 px-6 bg-themePink rounded-lg text-themeRed">Delete</button></div> */}
                          </div>
                          <h6 className="font-small text-sm text-black text-opacity-40">
                            <Moment format="D MMM YYYY , hh:mm A">
                              {comment.createdAt ?? ""}
                            </Moment>
                          </h6>
                          <p className="font-normal text-md">
                            {comment.comment}
                          </p>
                          <span className=" text-black text-opacity-40 text-xs">
                            By : {comment.User.firstName}{" "}
                            {comment.User.lastName}
                          </span>
                        </div>
                        <div className="space-y-6 pl-10">
                          {data?.data?.replies?.map((reply) =>
                            reply.CommentId === comment.id ? (
                              <>
                                <div>
                                  <div className="space-y-1 ">
                                    <div className="flex justify-between">
                                      {/* <h3 className="font-medium text-base"></h3> */}
                                      {/* <div><button onClick={() => remove_comment(reply.id)} className="text-xs px-4 bg-themePink rounded-lg text-themeRed">Delete</button></div> */}
                                    </div>

                                    <h6 className="font-small text-sm text-black text-opacity-40">
                                      <Moment format="D MMM YYYY , hh:mm A">
                                        {reply.createdAt ?? ""}
                                      </Moment>
                                    </h6>
                                    <p className="font-normal text-md">
                                      {reply.comment}
                                    </p>
                                    <span className=" text-black text-opacity-40 text-xs">
                                      By : {reply.User.firstName}{" "}
                                      {reply.User.lastName}
                                    </span>
                                  </div>
                                </div>
                              </>
                            ) : (
                              ""
                            )
                          )}

                          {/* <button
                              className="bg-white font-medium text-base text-black text-opacity-60 
                                    px-5 py-2 flex items-center gap-x-2"
                            >
                              <FaReply />
                              <span>Reply</span>
                            </button> */}
                          <input
                            id="textarea"
                            name="comment"
                            placeholder="Enter comments.."
                            className={textareaStyle}
                            onChange={(e) => setReply(e.target.value)}
                            value={reply}
                            rows="5"
                          />
                          <div className="flex justify-end items-center gap-x-3">
                            <button
                              onClick={() => setReply("")}
                              className="font-normal text-xl text-themeBlue bg-transparent border 
                          border-themeBlue px-4 py-2 rounded-lg hover:bg-themeBlue hover:text-white"
                            >
                              Cancel
                            </button>
                            <button
                              onClick={() => add_reply(comment.id)}
                              className="font-normal text-xl text-white bg-themeBlue border 
                          border-themeBlue px-4 py-2 rounded-lg hover:bg-transparent hover:text-themeBlue"
                            >
                              Reply
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <button
                  onClick={() => modal_open()}
                  className="mt-5 py-3 px-16 bg-themeBlue border border-themeBlue rounded-lg text-white hover:bg-white hover:text-themeBlue"
                >
                  Add Comment
                </button>
              </div>
            </div>
            <div className="lg:col-span-4">
              <div className="lg:float-right space-y-4">
                <h3 className="font-medium text-2xl text-themeBlue">
                  More Info
                </h3>
                <div className="flex items-center gap-x-12">
                  <ul className="space-y-3">
                    <li>ID</li>
                    <li>Status</li>
                    <li>Created At</li>
                    <li>Created By</li>
                  </ul>
                  <ul className="space-y-3">
                    <li>#{data?.data?.booking?.id ?? ""}</li>
                    <li>{data?.data?.booking?.bookingStatus ?? ""}</li>
                    <li>
                      <Moment format="D MMM YYYY , hh:mm A">
                        {data?.data?.booking?.createdAt ?? ""}
                      </Moment>
                    </li>
                    <li>
                      {data?.data?.booking.User.firstName ?? ""}{" "}
                      {data?.data?.booking.User.lastName ?? ""}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>

      <Modal size="xl" isOpen={CommentOpen} onClose={CommentOnClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Comment</ModalHeader>

          <ModalCloseButton />
          {loading ? (
            <Loader2 />
          ) : (
            <>
              <ModalBody>
                <div className="w-full">
                  <textarea
                    name="comment"
                    placeholder="Enter comments.."
                    className={textareaStyle}
                    onChange={(e) => setNewComment(e.target.value)}
                    value={newcomment}
                    rows="5"
                  ></textarea>
                </div>
              </ModalBody>

              <ModalFooter>
                <div className="space-x-2">
                  <button
                    className="py-1 w-[100px] border border-themeBlue text-themeBlue rounded-lg"
                    onClick={CommentOnClose}
                  >
                    Cancel
                  </button>

                  <button
                    className="py-1 w-[100px] border bg-themeBlue border-themeBlue text-white rounded-lg"
                    onClick={add_comment}
                  >
                    Add
                  </button>
                </div>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </section>
  );
}
